import CloseIcon from '@mui/icons-material/Close'
import DragIcon from '@mui/icons-material/DragIndicator'
import Tooltip from '@mui/material/Tooltip'
import moment from 'moment'
import { Paper } from '@components'
import * as dateFormaters from 'handsontable/utils/convertDateUtil'

const TYPES = {
  constant: 'Constant:',
  variable: 'Variable:',
  autonumber: 'Auto #',
  date: 'Date:',
  random: 'Random',
}

export const Segment = ({ segment, colors, onEdit, onRemove, dragListeners }) => {
  function fieldsetDateFilter(rawDate = 0, fieldsetField = { date: {} }) {
    rawDate = moment(rawDate)
    const formatString = dateFormaters.convertDateFieldToMomentJsFormat(fieldsetField)
    return rawDate.format(formatString)
  }

  function getElementDisplayName(element) {
    let val = ''

    if (
      element.segment_type === 'autonumber' &&
      element.name &&
      element.name.toLowerCase() !== 'auto #'
    ) {
      val += ` [${element.name}]`
    }

    if (element.segment_type === 'constant' && element.constant_value) {
      val += ` ${element.constant_value}`
    }

    if (element.segment_type === 'date' && element.date) {
      val += ` ${fieldsetDateFilter(new Date(), element)}`
    }

    if (element.segment_type === 'variable' && element.name) {
      val += ` [${element.name}]`
    }

    return val
  }

  return (
    <Paper
      elevation={2}
      style={{
        maxWidth: 200,
        width: 200,
        borderRadius: 4,
        padding: 8,
        fontSize: 14,
        color: colors[segment.segment_type],
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        userSelect: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
      }}
      onClick={() => {
        onEdit(segment)
      }}
    >
      <DragIcon style={{ marginRight: 8 }} {...dragListeners} />
      <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
        <span style={{ textTransform: 'uppercase' }}>{TYPES[segment.segment_type]}</span>
        <Tooltip title={getElementDisplayName(segment)}>
          <span>{getElementDisplayName(segment)}</span>
        </Tooltip>
      </div>
      <CloseIcon
        onClick={e => {
          e.stopPropagation()
          onRemove(segment)
        }}
      />
    </Paper>
  )
}
